<template>
    <div
        v-if="widget.active"
        v-tooltip.bottom="$t('advanced.go_to_widget', { i18nFallback: 'Go to widget' })"
        class="icon-container"
        @click.stop="scrollToWidget()"
        @mouseenter="isHovered = true"
        @mouseleave="isHovered = false"
        @touchstart.prevent="handleTouchStart"
    >
        <img
            class="right-arrow-icon-widgets"
            :class="{ 'default-icon': !isHovered, 'selected-icon': isHovered }"
            :src="
                isHovered
                    ? '/img/svg-icons/right-arrow-icon-selected.svg'
                    : '/img/svg-icons/right-arrow-icon.svg'
            "
        />
    </div>
</template>

<script>
import { Vue, Prop, Component } from 'vue-property-decorator';
import { AngularLocaleBundle } from '@/angular-bridge/modules/i18n';
import { AngularDirective } from '@/vue/decorators/angular-interop';

@Component({})
@AngularDirective('vrm-scroll-to-widget-icon')
@AngularLocaleBundle('advanced')
export default class VrmScrollToWidgetIcon extends Vue {
    @Prop() widget;
    isHovered = false; // Track hover state

    scrollToWidget() {
        const widgetId = this.widget.idCustomWidget
            ? `widget-${this.widget.idCustomWidget}`
            : `widget-${this.widget.idWidget}`;

        const widgetElement = document.getElementById(widgetId);

        if (widgetElement) {
            widgetElement.scrollIntoView({ behavior: 'smooth', block: 'center' });

            widgetElement.classList.add('widget-highlight');

            setTimeout(() => {
                widgetElement.classList.remove('widget-highlight');
            }, 7000);
        }
    }

    //This is done to fix the bug which caused the hover to always be true on mobiles.
    handleTouchStart() {
        this.isHovered = true;
        this.scrollToWidget();
        setTimeout(() => {
            this.isHovered = false;
        }, 2000); // Reset hover effect after 2 seconds to mimic desktop hover
    }
}
</script>
